import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  paper: {
    width: '29.75rem',
  }
}));
